class MFRProductStickyBar {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      firstSection: "main .shopify-section:first-child",
      stickyBarForm: ".product-sticky-bar__form",
      stickyBarCurrentPrice: "input[name='properties[_current_price]']",
      stickyBarCounter: "#sticky-counter",
      stickyBarPriceCounter: "#sticky-price",
      stickyBarQuantitySelector: ".quantity-selector",
      stickyBarAddOnsQuantitySelector: ".addons-quantity-selector__input",
      stickyBarAddOnsPriceSelector: ".addons-price-selector__input",
    };

    this.options = options;

    this.states = {
      currentProductQty: 1,
      currentProductPrice: 0,
      currentAddOnsProductQty: 0,
      currentTotalPrice: 0,
    };

    this.init();
  }

  init() {
    this.$stickyBarForm = this.$element
      .find(this.selectors.stickyBarForm)
      .find("form");
    this.$stickyBarCurrentPrice = this.$element.find(
      this.selectors.stickyBarCurrentPrice
    );
    this.$stickyBarCounter = this.$element.find(
      this.selectors.stickyBarCounter
    );
    this.$stickyBarPriceCounter = this.$element.find(
      this.selectors.stickyBarPriceCounter
    );
    this.$quantitySelector = this.$element.find(
      this.selectors.stickyBarQuantitySelector
    );

    this.states.currentProductPrice = parseInt(
      this.$stickyBarCurrentPrice.val()
    );

    this.$quantitySelector.on(
      "mfr:quantity-changed",
      this.ProductStickyCounter.bind(this)
    );

    this.addOnComponent.on(
      "mfr:addons-quantity-changed",
      this.ProductStickyCounter.bind(this)
    );

    this.$stickyBarForm.on("submit", this.ProductStickyFormSubmit.bind(this));

    if (!gsap || !ScrollTrigger || !ScrollTrigger.create) return;

    this.$firstSection = $(this.selectors.firstSection);

    this.initScrollTrigger();
  }

  initScrollTrigger() {
    ScrollTrigger.create({
      trigger: this.$firstSection,
      start: "0% top",
      endTrigger: "html",
      end: "bottom top",
      onToggle: (self) => {
        this.$element.toggleClass("is-active", self.isActive);
      },
    });
  }

  ProductStickyFormSubmit() {
    $(document).trigger("mfr:add-to-cart");
  }

  ProductStickyCounter() {
    this.states.currentProductQty = parseInt(
      this.$quantitySelector.find(".quantity-selector__input").val()
    );

    this.states.currentTotalPrice =
      this.states.currentProductPrice * this.states.currentProductQty;

    this.$stickyBarPriceCounter.text(`$${this.states.currentTotalPrice}`);

    if (isNaN(this.states.currentAddOnsProductQty)) {
      this.$stickyBarCounter.hide();
    } else {
      this.$stickyBarCounter.text(
        `(${
          this.states.currentProductQty + this.states.currentAddOnsProductQty
        })`
      );
      this.$stickyBarCounter.show();
    }
  }
}